import { Heading, Text } from '@talkdesk/cobalt-react-typography'
import { Icon } from '@talkdesk/cobalt-react-icon'
import Flex from '@talkdesk/cobalt-react-flex'
import Box from '@talkdesk/cobalt-react-box'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'

const MFAHeader = ({ icon, iconColor, title, subtitle }) => {
  const theme = useTheme()
  const resolvedColor =
    iconColor && theme[iconColor] ? theme[iconColor] : iconColor

  return (
    <Flex direction='column' alignX='center' paddingBottom={6}>
      {icon && (
        <Box paddingBottom={3}>
          <Icon name={icon} color={resolvedColor} size='large' />
        </Box>
      )}
      <Flex direction='column' alignX='center' paddingTop={3}>
        <Heading level={3}>{title}</Heading>
        <Text textAlign='center' color={theme.gray600}>
          {subtitle}
        </Text>
      </Flex>
    </Flex>
  )
}

export default MFAHeader
